import AmwayPopup from "./AmwayPopup";

export default AmwayPopup;